import { Table, TableHead, TableRow, TableCell, TableBody, Typography, Paper, Chip, Stack } from '@mui/material';
import { filterProductosById } from './utils/inventarioFilters';

export default function ResumenInventario({
  productos,
  calcularStock,
  obtenerValorInventario,
  productId = 'TODOS',
  metodo,
}) {
  const productosFiltrados = filterProductosById(productos, productId);
  const totalValor = productosFiltrados.reduce(
    (acc, p) => acc + (obtenerValorInventario(p.id) || 0),
    0
  );

  return (
    <Paper sx={{ p: 2 }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} spacing={1} sx={{ mb: 2 }}>
        <Typography variant="h6">Stock valorizado</Typography>
        <Chip label={`Total: Bs. ${totalValor.toFixed(2)}`} color="primary" variant="outlined" />
      </Stack>
      {metodo && (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
          Método: {metodo}
        </Typography>
      )}
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: '#eee' }}>
            <TableCell>Producto</TableCell>
            <TableCell align="right">Stock</TableCell>
            <TableCell align="right">Valor</TableCell>
            <TableCell align="right">Valor promedio/u</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {productosFiltrados.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                <Typography color="text.secondary">No hay productos con el filtro seleccionado.</Typography>
              </TableCell>
            </TableRow>
          ) : (
            productosFiltrados.map((p) => {
              const stock = calcularStock(p.id) || 0;
              const valor = obtenerValorInventario(p.id) || 0;
              return (
                <TableRow key={p.id}>
                  <TableCell>{p.nombre}</TableCell>
                  <TableCell align="right">{stock}</TableCell>
                  <TableCell align="right">{valor.toFixed(2)}</TableCell>
                  <TableCell align="right">{(valor / (stock || 1)).toFixed(2)}</TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}
